<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Vessel Flag Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.vesFlag }}</td>
            <td class="text-xs-left">{{ props.item.vesFlagDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['vesselReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Vessel Flag
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="flagDialog" width="800px" lazy v-if="checkAccess(['vesselReview'])" persistent >
        <flag-dialog :flagForm="flagForm" @close="doClose" :newFlag="newFlag"></flag-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Vessel Flag? ({{deleteVesFlag}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import FlagDialog from './FlagDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Vessel Flag Code', align: 'left', value: 'vesFlag' },
        { text: 'Vessel Flag Description', align: 'left', value: 'vesFlagDesc' }
      ],
      flagForm: {
        vesFlag: undefined,
        vesFlagDesc: undefined
      },
      flagDialog: undefined,
      newFlag: undefined,
      loading: false,
      promptRemove: false,
      selectedVesFlag: undefined,
      deleteVesFlag: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.vessel.menu.getVslFlags
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((VslFlag) => {
              const convertVslFlag = {
                vesFlag: VslFlag.vesFlag,
                vesFlagDesc: VslFlag.vesFlagDesc
              }
              this.items.push(convertVslFlag)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Flag) {
      const apiURI = this.$store.state.vessel.menu.getVslFlag
      const expand = {
        vesFlag: Flag.item.vesFlag
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.flagForm.vesFlag = data.vesFlag.vesFlag
          this.flagForm.vesFlagDesc = data.vesFlag.vesFlagDesc
        }
        this.flagDialog = true
      }
    },
    doClose() {
      this.flagDialog = false
      this.newFlag = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.flagDialog = true
      this.newFlag = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVesFlag = data
        this.deleteVesFlag = data.vesFlag + ' - ' + data.vesFlagDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.vessel.menu.deleteFlag
      if (apiURI) {
        const expand = this.selectedVesFlag
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.fetchData()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['vesselReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    FlagDialog: FlagDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
